
import {Vector2} from "./delme_globals";

export enum VIEWER_INTERACTIONMODES {
    "NONE",
    "PANNING",
    "ROTATE",
    "WAIT_FOR_DROP",
    "SELOBDELETE",
    "OBJECT_MOVE",
    "OBJECT_ROTATE",
    "OBJECT_SCALING"
}

export class OwayoZoomInfoObject {
    factor =1.0;
    target;
    origin : Vector2;
    //Gibt an, ob wir uns aktuell in einem Zoomvorgang befinden. Pinch vs. Mauserad (Mausrad liefert distinkte Tiks, Pinch ist ongoing)
    ongoing = false;
    startFactor :number|null= null

    constructor() {
        //* Das Ziel des Zooms (Kameraposition). Wird berechnet, wenn zoom.ongoing false ist. Die Kamera wandert in Richtung dieser Koordinaten.
        this.target = new Vector2(NaN,NaN);

        //Ausgangspunkt, auf dem bei Zoomout zurückgegangen wird
        this.origin = new Vector2(0,0);
    }
}

export class OwayoJSViewerDimensionInfoObject {
    viewer:{width, height};
    model:{x,y,z};
    constructor(viewerWidth : number, viewerHeight : number) {
        this.viewer = {
            width	: viewerWidth,
            height	: viewerHeight
        };
        this.model = {
            x: 0,
            y: 0,
            z: 0
        }
    }
    getMaxModelDimension = ()=>Math.max(this.model.x, this.model.y, this.model.z);
}

export const WEBGL_ERROR_REASONS = {
    WEBGL_ERROR_BAD_IOS_VERSION         : "konf_webglError_badIOS",
    WEBGL_ERROR_IE_BADWINVERSION        : "konf_webglError_IE_badWin",
    WEBGL_ERROR_IE_OLDVERSION           : "konf_webglError_IE_oldVersion",
    WEBGL_ERROR_CHROME_OLDMACOS         : "konf_webglError_Chrome_oldMacOS",
    WEBGL_ERROR_CHROME_OLDVERSION       : "konf_webglError_Chrome_oldVersion",
    WEBGL_ERROR_CHROME_BADWINVERSION    : "konf_webglError_Chrome_badWin",
    WEBGL_ERROR_CHROME_ANDROID          : "konf_webglError_Chrome_Android",
    WEBGL_ERROR_SAFARI_OLDVERSION       : "konf_webglError_Safari_oldVersion",
    WEBGL_ERROR_OPERA_OLDVERSION        : "konf_webglError_Opera_oldVersion",
    WEBGL_ERROR_FIREFOX_OLDMACOS        : "konf_webglError_Firefox_oldMacOs",
    WEBGL_ERROR_FIREFOX_BADWINVERSION   : "konf_webglError_Firefox_badWin",
    WEBGL_ERROR_FIREFOX_XP              : "konf_webglError_Firefox_XP",
    WEBGL_ERROR_FIREFOX_BUG                 : "konf_webglError_Firefox_Bug",
    WEBGL_ERROR_GENERIC_OLDVERSION      : "konf_webglError_Generic_oldVersion",
    WEBGL_ERROR_GENERIC                 : "konf_webglError_Generic"
};